import type { OutputType } from '@expostreamer/shared-types'

// 'webrtc' isn't a backend ffmpeg OutputType (no ffmpeg process is involved
// in a screen share) — it only exists on the frontend's VideoSource, hence
// this separate union rather than extending OutputType itself.
export type FrontendSourceType = OutputType | 'webrtc'

// NOTE: NONE is 'NONE' (not 'none') to match the backend's OUTPUT_TYPE.NONE
// (src/types/outputTypes.ts) — they used to disagree, which meant
// `item.outputType !== SourceType.NONE` was always true and the PLAY button
// never actually hid itself for non-playable instances.
export const SourceType: Record<'WEBSOCKET' | 'HLS' | 'FILE' | 'NONE' | 'WEBRTC', FrontendSourceType> = {
  WEBSOCKET: 'websocket',
  HLS: 'hls',
  FILE: 'file',
  NONE: 'NONE',
  WEBRTC: 'webrtc',
}
